import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Creators as saveBSEActions } from '../../../../../../../../domain/useCases/bse/registerUseCase/actions';
import { Creators as bseActions } from '../../../../../../../../domain/useCases/bse/getFormBseUseCase';
import useFormIndex from '../../hooks/useFormIndex';
import IndexView from './FormIndexView';
import { formatValuesSave, formatValuesLoad } from './values';
import useSnackbarFields from '../../hooks/useSnackbarFields';

interface FormIndexViewControllerProps {
  handlerBack?: () => void;
}

const FormIndexViewController = ({
  handlerBack
}: FormIndexViewControllerProps) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { fieldsSnackbar, validateCommon, Types } = useSnackbarFields();
  const {
    operationNumber: idRequestx,
    isLoading: isSaving,
    isSuccess: isSaved
  } = useSelector((state: any) => state.registerBse);
  const { isLoading: isLoadingData, data: formBse } = useSelector(
    (state: any) => state.getFormBse
  );
  const { request } = useSelector((state: any) => state.procedureStudentStatus);

  const idRequest = request?.id || idRequestx || 0;

  const {
    formData: formDataLoaded,
    formIncome: formIncomeLoaded,
    formExpenses: formExpensesLoaded,
    formAdditionalInformation: formAdditionalInformationLoaded,
    formFamily: formFamilyLoaded,
    formSavingsAndDebts: formSavingsAndDebtsLoaded,
    formHealth: formHealthLoaded,
    formLivingPlace: formLivingPlaceLoaded
  } = formatValuesLoad(formBse);

  const { openNext, props } = useFormIndex();
  const { props1, props2, props3, props4, props5, props6, props7, props8 } =
    props;

  const initialState = {
    error: false,
    isOk: false
  };

  const [formData, setFormData] = useState({
    fields: formDataLoaded
  });
  const [formDataStates, setFormDataStates] = useState({
    ...initialState
  });
  const [formIncome, setFormIncome] = useState({
    fields: formIncomeLoaded
  });
  const [formIncomeStates, setFormIncomeStates] = useState({
    ...initialState
  });
  const [formExpenses, setFormExpenses] = useState({
    fields: formExpensesLoaded
  });
  const [formExpensesStates, setFormExpensesStates] = useState({
    ...initialState
  });
  const [formAdditionalInformation, setFormAdditionalInformation] = useState({
    fields: formAdditionalInformationLoaded
  });
  const [formAdditionalInformationStates, setFormAdditionalInformationStates] =
    useState({
      ...initialState
    });
  const [formHealth, setFormHealth] = useState({
    fields: formHealthLoaded
  });
  const [formHealthStates, setFormHealthStates] = useState({
    ...initialState
  });
  const [formLivingPlace, setFormLivingPlace] = useState({
    fields: formLivingPlaceLoaded
  });
  const [formLivingPlaceStates, setFormLivingPlaceStates] = useState({
    ...initialState
  });
  const [formFamily, setFormFamily] = useState({
    fields: formFamilyLoaded
  });
  const [formFamilyStates, setFormFamilyStates] = useState({
    ...initialState
  });
  const [formSavingsAndDebts, setFormSavingsAndDebts] = useState({
    fields: formSavingsAndDebtsLoaded
  });
  const [formSavingsAndDebtsStates, setFormSavingsAndDebtsStates] = useState({
    ...initialState
  });
  const [isMarried, setIsMarried] = useState<boolean | string>('');
  const handleBackButton = () => history.goBack();

  const handleSave = (
    formName: string,
    fields: any,
    isComplete: boolean,
    save = true
  ) => {
    let data: any = {
      ...formData.fields,
      ...formIncome.fields,
      ...formExpenses.fields,
      ...formAdditionalInformation.fields,
      ...formLivingPlace.fields,
      ...formFamily.fields,
      ...formSavingsAndDebts.fields,
      ...formHealth.fields
    };
    data = { ...data, ...fields };

    if (formName === 'data') {
      setFormData({ fields });
      setFormDataStates({ error: !isComplete, isOk: isComplete });
    }
    if (formName === 'income') {
      setFormIncome({ fields });
      setFormIncomeStates({ error: !isComplete, isOk: isComplete });
    }
    if (formName === 'expenses') {
      setFormExpenses({ fields });
      setFormExpensesStates({ error: !isComplete, isOk: isComplete });
    }
    if (formName === 'additionalInformation') {
      setFormAdditionalInformation({ fields });
      setFormAdditionalInformationStates({
        error: !isComplete,
        isOk: isComplete
      });
    }
    if (formName === 'health') {
      setFormHealth({ fields });
      setFormHealthStates({
        error: !isComplete,
        isOk: isComplete
      });
    }
    if (formName === 'livingPlace') {
      setFormLivingPlace({ fields });
      setFormLivingPlaceStates({ error: !isComplete, isOk: isComplete });
    }
    if (formName === 'family') {
      setFormFamily({ fields });
      setFormFamilyStates({ error: !isComplete, isOk: isComplete });
    }
    if (formName === 'savingsAndDebts') {
      setFormSavingsAndDebts({ fields });
      setFormSavingsAndDebtsStates({ error: !isComplete, isOk: isComplete });
    }
    const dataBse = formatValuesSave(data).map((f) => ({
      id: f.id,
      value: f.value || ''
    }));
    if (save) {
      dispatch(
        saveBSEActions.registerBse(idRequest || 0, 'UTP+Portal', dataBse, false)
      );
    }
  };

  useEffect(() => {
    if (!formBse) dispatch(bseActions.getFormBse(idRequest || 0));
  }, []);
  useEffect(() => {
    if (isSaved === true)
      validateCommon(Types.success, '¡Listo!', 'Tu avance ha sido guardado');
    if (isSaved === false)
      validateCommon(Types.error, '¡Ups!', 'Parece que hubo un error');
  }, [isSaved]);
  useEffect(() => {
    if (formBse) {
      const {
        formData: formDataLoaded1,
        formIncome: formIncomeLoaded1,
        formExpenses: formExpensesLoaded1,
        formLivingPlace: formLivingPlaceLoaded1,
        formSavingsAndDebts: formSavingsAndDebtsLoaded1,
        formFamily: formFamilyLoaded1
      } = formatValuesLoad(formBse);
      setFormData({ fields: formDataLoaded1 });
      setFormIncome({ fields: formIncomeLoaded1 });
      setFormExpenses({ fields: formExpensesLoaded1 });
      setFormLivingPlace({ fields: formLivingPlaceLoaded1 });
      setFormSavingsAndDebts({ fields: formSavingsAndDebtsLoaded1 });
      setFormFamily({ fields: formFamilyLoaded1 });

      setIsMarried(
        formDataLoaded1?.dataEstadoCivil !== ''
          ? ['2', '5'].includes(formDataLoaded1?.dataEstadoCivil)
          : ''
      );
    }
  }, [formBse]);

  useEffect(() => {
    if (formData) {
      setIsMarried(
        formData?.fields?.dataEstadoCivil !== ''
          ? ['2', '5'].includes(formData?.fields?.dataEstadoCivil)
          : ''
      );
    }
  }, [formData]);

  return (
    <IndexView
      isLoadingData={isLoadingData}
      isSaving={isSaving}
      idRequest={idRequest}
      handleNext={openNext}
      formData={{ ...props1, ...formData, ...formDataStates }}
      formFamily={{ ...props2, ...formFamily, ...formFamilyStates }}
      formIncome={{ ...props3, ...formIncome, ...formIncomeStates }}
      formExpenses={{ ...props4, ...formExpenses, ...formExpensesStates }}
      formSavingsAndDebts={{
        ...props5,
        ...formSavingsAndDebts,
        ...formSavingsAndDebtsStates
      }}
      formLivingPlace={{
        ...props6,
        ...formLivingPlace,
        ...formLivingPlaceStates
      }}
      formHealth={{
        ...props7,
        ...formHealth,
        ...formHealthStates
      }}
      formAdditionalInformation={{
        ...props8,
        ...formAdditionalInformation,
        ...formAdditionalInformationStates
      }}
      handleBackButton={handlerBack || handleBackButton}
      handleSave={handleSave}
      fieldsSnackbar={fieldsSnackbar}
      isMarried={isMarried}
    />
  );
};

FormIndexViewController.defaultProps = {
  handlerBack: null
};

export default FormIndexViewController;
